import { NoteDirection } from "@/shared/Components";
import type { Note } from "@/services/api";
import type { FC } from "react";
import styles from "../../styles.module.scss";
interface Props {
  isShowFlag: boolean;
  flag: Note["direction"];
}

export const CommitmentFlag: FC<Props> = ({ isShowFlag, flag }) => {
  return (
    <>
      {isShowFlag && (
        <div className={styles.flag}>
          <NoteDirection direction={flag} />
        </div>
      )}
    </>
  );
};
